/**
 * It takes a number, converts it to a string, and returns a string with the first digit and the second
 * digit separated by a space
 * @param {number} value - number - the number to format
 * @returns a string that is the concatenation of the left digit and the right digit.
 */
export const formatDigit = (value: number) => {
  const leftDigit = value >= 10 ? value.toString()[0] : '0';
  const rightDigit = value >= 10 ? value.toString()[1] : value.toString();
  return `${leftDigit}${rightDigit}`;
};
